import { BomDto } from "src/dtos/bom/BomDto";
import { ProductOrderDto } from "src/dtos/productOrder/ProductOrderDto";
import { ProductResultDto } from "src/dtos/productResult/ProductResultDto";
import { defaultPrdInspectResultDto, PrdInspectResultDto } from "src/dtos/prdInspectResult/prdInspectResultDto";
import { WmsStockLotDto } from "src/dtos/wmsLot/wmsStockLotDto";
import { formatDate, toLocalDateTime } from "src/utils/string/stringUtil";

export type PRD3012_R01WorkTimeProcessType = 'workStart' | 'workEnd' | 'workStartReset' | 'workEndReset';

export interface PRD3012_R01Dto {
	productOrderHeaderDto: PRD3012_R01HeaderDto;
	productResultHeaderDto: PRD3012_R01ProductResultDto;
	wmsStockLotDtoList: PRD3012_R01LotDto[];
	bomDtoList: PRD3012_R01DetailDto[];
	prdInspectResultDtoList: PrdInspectResultDto[];
}

export interface PRD3012_R01HeaderDto extends ProductOrderDto {

	itemSpec: string;
	itemUnit: string;
	itemCost: number;

	productResultNo: string;
	productDt: string | undefined;

	productEmp: string;
	productEmpNm: string;

	warehouseCd: string;
	warehouseNm: string;
	outWarehouseCd: string;
	badWarehouseCd: string;

	logicCenter: string;
	logicCenterNm: string;
	productQty: number;
	badQty: number;
	acceptQty: number;

	itemStatus: string;

	basOrderType: string;
	basOrderNo: string;
	basOrderItemNo: string;

	customNm: string;

	workStartDt?: string;
	workEndDt?: string;
	timeParam?: string;
	plcCount: number;
	pendingLotQty: number;
}

export const defaultPRD3012_R01HeaderDto: PRD3012_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productOrderNo: '',
	compCd: '',
	compNm: '',
	orderDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	workProcess: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	orderQty: 0,
	orderEmp: '',
	orderEmpNm: '',
	productPlanNo: '',
	resultQty: 0,
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	closeTag: "N",
	instructions: '',
	remark: '',

	customNm: '',

	itemCost: 0,

	productResultNo: '',
	productDt: formatDate(new Date()),

	productEmp: '',
	productEmpNm: '',

	warehouseCd: '',
	warehouseNm: '',
	outWarehouseCd: '',
	badWarehouseCd: '',

	logicCenter: '',
	logicCenterNm: '',
	productQty: 0,
	badQty: 0,
	acceptQty: 0,

	itemStatus: '',

	workStartDt: undefined,
	workEndDt: undefined,
	timeParam: toLocalDateTime(new Date()),
	plcCount: 0,
	pendingLotQty: 0,

	inserted: false,
	isModified: false,
};

export interface PRD3012_R01ProductResultDto extends ProductResultDto {
	outWarehouseCd: string;
	badWarehouseCd: string;
}

export const defaultPRD3012_R01ProductResultDto: PRD3012_R01ProductResultDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	productResultNo: '',
	compCd: '',
	compNm: '',
	productDt: formatDate(new Date()),
	orderType: '',
	workplaceCd: '',
	workplaceNm: '',
	jobTeam: '',
	itemCd: '',
	itemStatus: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	productOrderNo: '',
	orderQty: 0,
	productEmp: '',
	productEmpNm: '',
	workStartDt: toLocalDateTime(new Date()),
	workEndDt: undefined,
	productQty: 0,
	badQty: 0,
	acceptQty: 0,
	logicCenter: '',
	warehouseCd: '',
	warehouseNm: '',
	basOrderType: '',
	basOrderNo: '',
	basOrderItemNo: '',
	kpiYn: '',
	inspectQty: 0,
	inspectYn: 'N',

	outWarehouseCd: '',
	badWarehouseCd: '',

	inserted: false,
	isModified: false,
};


export interface PRD3012_R01LotDto extends WmsStockLotDto {

}

export const defaultPRD3012_R01LotDto: PRD3012_R01LotDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	warehouseCd: '',
	warehouseNm: '',
	lotNo: '',
	purchaseLotNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemUnit: '',
	itemStatus: '',
	lotQty: 0,
	transportNo: '',
	itemNo: '',
	remark: '',

	inserted: false,
	isModified: false,
};

export interface PRD3012_R01DetailDto extends BomDto {

	warehouseCd: string;
	warehouseNm: string;
	logicCenter: string;
	lotNo: string;
	itemStatus: string;
	itemNm: string;
	itemUnit: string;
	transportNo: string;
	itemNo: string;
	lotQty: number;
	bomUsingQty: number;
	transportQty: number;

}

export const defaultPRD3012_R01DetailDto: PRD3012_R01DetailDto = {

	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	prntItemcd: '',
	prntItemnm: '',
	childItemcd: '',
	childItemnm: '',
	itemSpec: '',
	bomSeq: 0,
	bomUseyn: '',
	bomUpdateNo: '',
	prntItemQty: 0,
	prntItemUnit: '',
	childItemUsage: 0,
	childItemUnit: '',
	fixLossqty: 0,
	materialIntype: 'PURCHASE',
	lossPercent: 0,
	remark: '',

	warehouseCd: '',
	warehouseNm: '',
	logicCenter: '',
	lotNo: '',
	itemStatus: '',
	itemNm: '',
	itemUnit: '',
	transportNo: '',
	itemNo: '',
	lotQty: 0,
	bomUsingQty: 0,
	transportQty: 0,

	inserted: false,
	isModified: false,
};


export interface PRD3012_R01InspectDto extends PrdInspectResultDto {

}

export const defaultPRD3012_R01InspectDto: PRD3012_R01InspectDto = {
	...defaultPrdInspectResultDto,
};
